import { useState, useRef, useCallback, useEffect } from "react";
import logger from "../utils/logger";
import i18n from "../i18n/index.js";

export default function useChat(api, user, speak) {
  const [messages, setMessages] = useState([
    { id: "1", role: "ai", text: `Hi ${user?.name || "there"}! I'm Nova. How can I help you stay focused?` }
  ]);
  const [userInput, setUserInput] = useState("");
  const [isSending, setIsSending] = useState(false);
  const messagesEndRef = useRef(null);
  const handleAIActionRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSend = useCallback(async () => {
    if (!userInput.trim() || isSending) return;
    setMessages(prev => [...prev, { id: Date.now().toString(), role: "user", text: userInput }]);
    const msg = userInput;
    setUserInput("");
    setIsSending(true);
    try {
      const res = await api.post("/chat", {
        message: msg,
        ai_mode: user?.ai_mode || "rule_based",
        language: i18n.language || "de",
      });
      setMessages(prev => [...prev, { id: (Date.now() + 1).toString(), role: "ai", text: res.data.text }]);
      if (res.data.action) handleAIActionRef.current?.(res.data.action);
      speak(res.data.text);
    } catch (e) {
      logger.error("Chat error:", e);
      setMessages(prev => [...prev, { id: (Date.now() + 1).toString(), role: "ai", text: "Sorry, please try again." }]);
    } finally { setIsSending(false); }
  }, [userInput, isSending, api, user?.ai_mode, speak]);

  const setAIActionHandler = useCallback((handler) => {
    handleAIActionRef.current = handler;
  }, []);

  return { messages, userInput, setUserInput, isSending, messagesEndRef, handleSend, setAIActionHandler };
}
